import React from 'react';
import RecoveryForm from '../../../components/LoginForm/recoverForm';

const RecoverForm = () => {
  return (
    <RecoveryForm nextPage={'/driver'} userType={'driver'} allowEmailOtp={true} />
  );
};

export default RecoverForm;
